// @flow
import * as React from "react";
import styled, { css } from "styled-components";
import Gettext from "../../../common/Gettext";
import Money from "../../../Money";
import HowMuchInBucks from "../../../HowMuchInBucks";
import * as Icons from "../../../Icons/Tournaments";

import * as S from "../styles";

import type { Tournament } from "../../../../redux/CommonTypes";

const Info = styled.div`
  display: flex;
  justify-content: space-between;
  flex-grow: 1;

  @media (max-width: 959px) {
    flex-direction: column;
  }

  @media (max-width: 479px) {
    width: 100%;
  }
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  color: #ffffff;

  @media (max-width: 959px) {
    flex-direction: row;
    font-size: ${({ theme }) =>
      theme.locale === "ar" ? theme.minFontSize : "12px"};

    :not(:last-child) {
      margin-bottom: 5px;
    }
  }
`;

const InfoTitle = styled.div`
  font-size: 10px;
  color: #ffffff;

  @media (max-width: 959px) {
    margin-right: ${({ theme }) => (theme.direction === "rtl" ? 0 : 5)}px;
    margin-left: ${({ theme }) => (theme.direction === "rtl" ? 5 : 0)}px;
  }

  @media (min-width: 960px) {
    margin-bottom: 5px;
  }
`;

const InfoItemContent = styled.div`
  display: flex;
  align-items: center;
`;

const Rating = styled.div`
  margin: 0 9px;
  color: ${({ theme }) => theme.accent};
`;

const HowManyParticipants = styled.div`
  color: ${({ theme }) => theme.lightWhiteForeground};

  ${({ theme }) => {
    if (theme.direction === "rtl")
      return css`
        margin-right: 5px;
      `;

    return css`
      margin-left: 5px;
    `;
  }};
`;

const MoneyContainer = styled(HowManyParticipants)`
  color: #ffffff;

  @media (max-width: 959px) {
    text-align: center;
  }
`;

type ItemConstructorProps = {
  title: React.Node,
  children: React.Node
};

function ItemConstructor({ children, title }: ItemConstructorProps) {
  return (
    <Item>
      <InfoTitle>{title}</InfoTitle>
      <InfoItemContent>{children}</InfoItemContent>
    </Item>
  );
}

type ParticipantProps = {
  participant_count: number,
  participation_status: 0 | 1 | 2,
  current_place: number,
  show_rating: boolean
};

function Participants({
  participation_status,
  participant_count,
  current_place,
  show_rating = false
}: ParticipantProps) {
  if (participation_status === 1 && show_rating === true) {
    return (
      <ItemConstructor
        title={
          <span>
            <Gettext>Your rating</Gettext>:
          </span>
        }
      >
        <Icons.Rating />
        <Rating># {current_place}</Rating>
        <Gettext>of</Gettext>
        <HowManyParticipants>{participant_count}</HowManyParticipants>
      </ItemConstructor>
    );
  }

  return (
    <ItemConstructor title={<span><Gettext>Participants</Gettext>:</span>}>
      <Icons.Person />
      <HowManyParticipants>{participant_count}</HowManyParticipants>
    </ItemConstructor>
  );
}

type InfoProps = {
  ...Tournament,
  show_rating?: boolean
};

export const InfoBlock = (props: InfoProps) => (
  <Info>
    <ItemConstructor
      title={
        <span>
          <Gettext>Tournament balance</Gettext>:
        </span>
      }
    >
      <Icons.Wallet />
      <MoneyContainer>
        <Money Value={S.Value} Symbol={S.Currency} currency="USD">
          {props.account_money}
        </Money>
      </MoneyContainer>
    </ItemConstructor>
    <ItemConstructor
      title={
        <span>
          <Gettext>Prize fund</Gettext>:
        </span>
      }
    >
      <Icons.Cup width="16px" height="20px" />
      <MoneyContainer>
        <HowMuchInBucks
          value={props.prize_fund}
          valueUSD={props.prize_fund_usd}
          valueStyle={S.Value}
          symbolStyle={S.Currency}
        />
      </MoneyContainer>
    </ItemConstructor>
    <Participants {...props} />
  </Info>
);



// WEBPACK FOOTER //
// ./src/components/Tournaments/Popups/Final/StartInfo.js